const iframeResizer = require("./vendor/iframeResizer.js")
;(function () {
  const targetClass = "vigil-project-embed"

  this.targets = []
  this.frames = []

  const uuidv4 = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }

  const onIframeResizeMessage = (e) => {}

  const createIframe = (target) => {
    const iframe = document.createElement("iframe")
    iframe.style.border = "none"
    iframe.style.width = "100%"
    iframe.style.height = "400px"
    iframe.scrolling = "no"
    iframe.allowFullscreen = true

    const params = Object.entries(target.dataset)
      .map((kv) => kv.map(encodeURIComponent).join("="))
      .join("&")

    iframe.id = uuidv4()
    iframe.src = "https://player.vigilproject.app?" + params

    if (!target.dataset.fillParent) {
      iframe.onload = () => iframeResizer(iframe)
    } else {
      iframe.style.height = target.offsetHeight
      iframe.style.width = target.offsetWidth
    }

    return iframe
  }

  const handlePageLoaded = () => {
    const targets = document.getElementsByClassName(targetClass)

    if (targets.length === 0) return
    this.targets = targets

    for (const target of this.targets) {
      iframe = createIframe(target)

      target.appendChild(iframe)

      this.frames.push(iframe)
    }
  }

  window.onmessage = onIframeResizeMessage
  window.addEventListener("load", handlePageLoaded)
})()
